import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import { F0TagRaw } from '@factorialco/f0-react'
import { Handle, NodeProps, Position } from '@xyflow/react'

import CollapsibleButton from 'modules/job_catalog/components/DevJobCatalogTree/components/CollapsibleButton'
import CollapsibleLine from 'modules/job_catalog/components/DevJobCatalogTree/components/CollapsibleLine'
import { useTreeContext } from 'modules/job_catalog/components/DevJobCatalogTree/context'
import { CustomNode } from 'modules/job_catalog/components/DevJobCatalogTree/types'
import {
  NODE_TYPES,
  getTextFromNodeType,
  isNodeType,
  nodeTypeIcon,
} from 'modules/job_catalog/lib/nodesUtils'

const Node = (props: NodeProps<CustomNode>) => {
  const { onToggleExpand } = useTreeContext()
  const nodeType = isNodeType(props.data.type) ? props.data.type : NODE_TYPES.ROOT
  const icon = nodeTypeIcon(nodeType)
  const isSelected = props.selected || false

  return (
    <Box justifyContent="center" alignItems="center">
      <Box
        position="relative"
        justifyContent="center"
        alignItems="center"
        style={{ width: '100%' }}
      >
        <Box position="relative" borderRadius={{ all: 'rel333' }} padding="s4">
          {isSelected && (
            <Box
              position="absolute"
              border={{ all: { color: 'viridian800', style: 'solid', width: 's4' } }}
              borderRadius={{ all: 'rel333' }}
              style={{
                top: '0',
                left: '0',
                right: '0',
                bottom: '0',
                pointerEvents: 'none',
              }}
            />
          )}
          <Avatar size="s64" label={props.data.name} />
        </Box>
        <Text weight="semibold" size="300" whiteSpace="breakSpaces" ellipsis color="grey1000">
          {props.data.name}
        </Text>
        <F0TagRaw text={getTextFromNodeType(props.data.type)} icon={icon} />
      </Box>
      <Handle type="target" position={Position.Top} style={{ visibility: 'hidden' }} />
      <Handle type="source" position={Position.Bottom} style={{ visibility: 'hidden' }} />
      <CollapsibleLine />
      <CollapsibleButton
        childrenCount={props.data.childrenCount}
        isExpanded={props.data.expanded}
        onClick={() => onToggleExpand(props.id)}
      />
    </Box>
  )
}

export default Node
